<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_330" data-name="Group 330" transform="translate(-315.731 -280.286)">
    <circle id="Ellipse_5" data-name="Ellipse 5" cx="35.201" cy="35.201" r="35.201" transform="translate(315.731 280.286)" fill="#fff"/>
    <g id="Group_15" data-name="Group 15" transform="translate(-3401.575 -850.394)">
      <g id="Group_13" data-name="Group 13">
        <path id="Path_31" data-name="Path 31" d="M3772,1163.173a5.04,5.04,0,0,0,.544-.321c.071-.046.136-.1.2-.147.115-.087.225-.178.332-.274a5.21,5.21,0,1,0-7.4-.678c.054.068.108.136.166.2.108.121.218.238.337.349a5.112,5.112,0,0,0,.483.4c.068.049.133.1.2.148a4.989,4.989,0,0,0,.55.323,7.462,7.462,0,0,0-3.586,2.095,8.038,8.038,0,0,0-.637.757,9.208,9.208,0,0,0-.786,1.258c-.019.036-.035.077-.054.113a14.128,14.128,0,0,1,2.671,7.595h13.539C3778.569,1167.752,3775.785,1164.15,3772,1163.173Z" fill="#1a1818"/>
      </g>
      <g id="Group_14" data-name="Group 14">
        <path id="Path_32" data-name="Path 32" d="M3742.673,1170.162a25.978,25.978,0,0,1-1.9-6.16,7.617,7.617,0,0,0-2-.829,4.935,4.935,0,0,0,.545-.321c.07-.046.135-.1.2-.147.116-.087.226-.178.332-.274a5.348,5.348,0,0,0,.574-.583,58.62,58.62,0,0,1-.455-6.821c0-.144,0-.273-.007-.391a5.189,5.189,0,0,0-7.515,7.117c.055.068.109.136.166.2.109.121.219.238.338.349a5.262,5.262,0,0,0,.482.4c.069.049.133.1.2.148a5.2,5.2,0,0,0,.55.323,7.463,7.463,0,0,0-3.585,2.095,8.2,8.2,0,0,0-.638.757,9.181,9.181,0,0,0-.785,1.258,16.64,16.64,0,0,0-1.556,7.708h13.96A17.52,17.52,0,0,1,3742.673,1170.162Z" fill="#1a1818"/>
      </g>
      <path id="Path_33" data-name="Path 33" d="M3744.529,1177.388a17.2,17.2,0,0,1,1.359-7.293c-2.959-5.671-2.786-13.881-2.854-15.774a2.4,2.4,0,0,1,.3-1.407.576.576,0,0,1,1.053.2c.724,3.782.981,7.794,3.126,11.15a2.892,2.892,0,0,0,1.518,1.181,6,6,0,0,0,2.016.193,4.975,4.975,0,0,1-.541-.323,2.2,2.2,0,0,1-.2-.15,4.157,4.157,0,0,1-.481-.391c-.12-.113-.233-.225-.338-.345-.06-.068-.112-.136-.165-.2a5.11,5.11,0,0,1-1.164-3.21,5.239,5.239,0,0,1,5.139-5.2,5.158,5.158,0,0,1,3.386,9.089c-.1.09-.218.18-.33.27-.068.045-.136.1-.2.143a4.975,4.975,0,0,1-.541.323c3.756.969,6.52,4.552,6.52,11.747Z" fill="#1a1818"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_05_03',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SA_05_03.vue